import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PremiumServiceCardComponent } from '../premium-service-card/premium-service-card.component';
import { EventsService, ShareMessagesService, UtilService, VariablesService } from '../shared/services';
import { SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';
import { PremiumServiceService } from './premium-service.service';
import { DialogService } from '../shared/components/dialog/service/dialog.service';
import { CloseBtnModule } from '../common/close-btn/close-btn.module';
import { MatButtonModule } from '@angular/material/button';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-premium-services',
  standalone: true,
  imports: [
    CommonModule,
    PremiumServiceCardComponent,
    SwiperModule,
    CloseBtnModule,
    MatButtonModule,
    MatBottomSheetModule,
    MatDialogModule
  ],
  templateUrl: './premium-services.component.html',
  styleUrls: ['./premium-services.component.scss']
})
export class PremiumServicesComponent {
  constructor(
    private util: UtilService,
    private vars: VariablesService,
    private premiumService: PremiumServiceService,
    private dialogService: DialogService,
    private bottomSheet: MatBottomSheet,
    private router: Router,
    private eventsService: EventsService,
    private actRoute: ActivatedRoute,
    private shareMessagesService: ShareMessagesService
  ) {}

  isMobile = false;
  selectedPlan = '';
  isLoading = false;
  @Input() type = '';
  @Input() fundraiser;
  @Input() campaignId;
  @Input() list;

  @ViewChild('confirmPlanRef', {static: false}) confirmPlanRef; 
  @ViewChild('successfulDialogRef', {static: true}) successfulDialogRef;
  @ViewChild('swiper', {static: true}) swiper;

  isConfirmed = false;
  url;
  message;

  info = {
    whatsappShareContent: {
      shareTitle: 'Share on Whatsapp',
      desc: 'We’ve even created a ready-to-send message just for you!'
    }
  }

  config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 'auto',
    initialSlide: 1,
    navigation: true,
    keyboard: true,
    scrollbar: false,
    loop: true,
    observer: true,
    preloadImages: false,
    spaceBetween: 16,
    centeredSlides: false,
    pagination: false,
    breakpoints: {
      992: {
        slidesPerView: 'auto',
        centeredSlides: false,
        allowTouchMove: true,
        loop: false,
        initialSlide: 0,
        observer: true,
      },
      768: {
        slidesPerView: 1.1,
        centeredSlides: true,
        allowTouchMove: true,
        navigation: true,
        loop: false,
        initialSlide: 0,
        observer: true,
      }
    }
  };

  premiumServicesList = [
    { id: 1, planName: 'Bronze', planDetails: 'Regular plan', planPrice: 'Free', planBtnLabel: 'Current Plan', 
      includes: [
        {id: 1, title: 'Start fundraiser for free', isChecked: true},
        {id: 2, title: 'Automated Story', isChecked: true },
        {id: 3, title: 'Standard Withdrawal', isChecked: true },
        {id: 4, title: 'Personalized Story', isChecked: false},
        {id: 5, title: 'Customised promotional banner', isChecked: false}, 
        {id: 6, title: 'Crowdfunding expert support', isChecked: false}, 
        {id: 7, title: 'Instant Document Approval', isChecked: false }, 
        {id: 8, title: 'Campaign visibility from Ketto', isChecked: false}
      ] 
    }, 
    { id: 2, planName: 'Silver', planDetails: 'Silver plan USP', planPrice: '5% <span>platform fees</span>', planBtnLabel: 'Upgrade to silver', 
      includes: [
        {id: 1, title: 'Start fundraiser for free', isChecked: true},
        {id: 2, title: 'Automated Story', isChecked: true },
        {id: 3, title: 'Standard Withdrawal', isChecked: true },
        {id: 4, title: 'Personalized Story', isChecked: true },
        {id: 5, title: 'Customised promotional banner', isChecked: true }, 
        {id: 6, title: 'Crowdfunding expert support', isChecked: true }, 
        {id: 7, title: 'Instant Document Approval', isChecked: false }, 
        {id: 8, title: 'Campaign visibility from Ketto', isChecked: false }
      ]
    },
    {
      id: 3, planName: 'Gold', planDetails: 'Ideal for urgent needs', planPrice: '7% <span>platform fees</span>', planBtnLabel: 'Upgrade to gold', 
      includes: [
        {id: 1, title: 'Start fundraiser for free', isChecked: true},
        {id: 2, title: 'Automated Story', isChecked: true },
        {id: 3, title: 'Standard Withdrawal', isChecked: true },
        {id: 4, title: 'Personalized Story', isChecked: true},
        {id: 5, title: 'Customised promotional banner', isChecked: true}, 
        {id: 6, title: 'Crowdfunding expert support', isChecked: true}, 
        {id: 7, title: 'Instant Document Approval', isChecked: true }, 
        {id: 8, title: 'Campaign visibility from Ketto', isChecked: true}
      ]
    }
  ]

  ngOnInit() {
    this.isMobile = this.util.isMobile();
  }
  onPlanPurchaseClicked(event) {
    this.selectedPlan = event;
    if (this.selectedPlan.toLowerCase() === 'bronze') {
      return;
    }
    if (this.isMobile) {
      this.bottomSheet.open(this.confirmPlanRef, {
        panelClass: 'ketto-premium-confirm-dialog'
      });
    } else {
      this.dialogService.openDialogViaTemplate(this.confirmPlanRef, {
        width: '400px',
        height: '235px',
        panelClass: 'ketto-premium-confirm-dialog'
      });
    }
  }

  onSwiperInit(event) {
    console.log(event, this.swiper);
  }

  onCancelClicked() {
    this.isConfirmed = false;
    this.closeDialogOrSheet();
  }

  closeDialogOrSheet() {
    if (this.isMobile) {
      this.bottomSheet.dismiss();
    } else {
      this.dialogService.closeAll();
    }
  }
  activatePlan() {
    this.isLoading = true;
    this.premiumService.activatePlan(this.campaignId, this.selectedPlan.toLowerCase()).subscribe({next: val => {
      if (val) {
        this.isLoading = false;
        this.closeDialogOrSheet();
        if (!this.isMobile) {
          const dialogRef2 = this.dialogService.openDialogViaTemplate(this.successfulDialogRef, {
            width: '606px',
            height: '447px',
            panelClass: 'ketto-premium-successfull-dialog',
            closeOnNavigation: true,
          });
          dialogRef2.afterClosed().subscribe(val => {
            this.goToFundraiser();
          });
        } else {
          const dialogRef1 = this.bottomSheet.open(this.successfulDialogRef, {
            panelClass: 'ketto-premium-successfull-dialog',
          });
          dialogRef1.afterDismissed().subscribe(val => {
            this.goToFundraiser();
          });
        }

      }
    }, error: error => {
        this.isLoading = false;
      }
    });
  }

  async getWhatsAppMessage() {
    this.fundraiser = this.vars.fundraiser;
    if (this.fundraiser) {
      this.message = this.shareMessagesService.getWhatsAppMessage3(this.fundraiser);
      const whatsAppDomain = this.util.isMobile() ? 'wa.me' : 'web.whatsapp.com/send';
      this.url = `https://${whatsAppDomain}?text=${this.message}`;
      this.shareMessagesService.shareEvents('whatsapp share', 17);
      setTimeout(() => window.open(this.url, '_blank'), 0);
      this.closeDialogOrSheet();
    }
  }

  goToFundraiser() {
    if (this.type === 'med') {
      const payload = {
        'eventName': 'skip_to_fundraiser',
        'event_type': 'campaign',
        'page_name': 'campaign_thank_you',
        'event_type_id': this.campaignId
      };
      this.eventsService.sendSystemEvent(payload).subscribe({next: 
        () => {
          this.router.navigate([`/fundraiser/${this.fundraiser.custom_tag}`], {});
        },
        error: (err) => {
          this.router.navigate([`/fundraiser/${this.fundraiser.custom_tag}`], {});
        }
      });
    } else {      
      const url = environment.manage_domain + '/manage/' + this.campaignId + '/dashboard';
      this.util.nativeNavigation(url);
    }
    
  }
}
